import { Component, OnInit, EventEmitter, Output, OnDestroy, Input, HostListener } from '@angular/core';
import { MenuServiceService } from '../services/menu/menu-service.service';
import { MainService } from '../services/main/main.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SocketsService } from '../services/shared/socket.service';
import { AuthService } from '../services/auth/auth.service';
import { LogoutComponentDialog } from './logout-dialog/logout.component';
import { Observable, of, Subscription } from 'rxjs';
import { GlobalFilterService, GlobalFilterObj } from 'src/app/services/shared/global-filter.service';
import { filter } from 'rxjs/operators';
import { SharedService } from '../services/shared/shared.service';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { getUserProfile, getUserProfiles, getDoctorSettings, setStoredLocations } from 'src/app/core/session';

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.scss'],
})
export class LayoutsComponent implements OnInit, OnDestroy {
  isExpanded = true;
  screenWidth: number;
  menuItems: Array<any>;
  white_background_menus = ['/app/contract/details', '/app/contract/list', '/app/help/faq', '/app/process-payment/details', '/app/accounts-receivable/details', '/app/contract/split-details', '/app/accounts-receivable/split-details', '/app/leads/details'];
  show_white_background = false;
  @Output() public sidenavToggle = new EventEmitter();
  userProfileData = localStorage.getItem('userProfileData') ? getUserProfile() : {};
  selectedProfileImage = this.userProfileData.doctor_image || this.userProfileData.profile_image || 'assets/img/png/profile_placeholder.png';
  firstName = this.userProfileData.enterprise_first_name ? this.userProfileData.enterprise_first_name + ' ' + this.userProfileData.enterprise_last_name : (this.userProfileData.agent_id ? this.userProfileData.agent_name : this.userProfileData.doctor_first_name + ' ' + this.userProfileData.doctor_last_name);
  locations: any[] = [];
  filteredOptions: Observable<any>;
  @Input() locationType: any;
  @Output() getUserSelected = new EventEmitter();
  locationId: any;
  locationDisabled: boolean;
  locationData: any;
  showAlloption: boolean = false;
  prevshowAlloption: boolean = false;
  role: any;
  financeData: any;
  ppViewMode: any;
  doctorSettings = getDoctorSettings();
  path: string;
  practiceName: string;
  arProposalCount: any;
  doctorInfo: any;
  globalSubscription: Subscription;
  instant_payout_config: any = getUserProfile().instant_payout_config;
  show_payout: any = 0;
  showTooltip: boolean = false;
  tooltipLeft: any;
  tooltipTop: any;
  sidenavHidden = false;
  // in_transit_payout: any = 0;
  constructor(
    public menu: MenuServiceService,
    public dialog: MatDialog,
    public mainService: MainService,
    public _socket: SocketsService,
    public router: Router,
    public authService: AuthService,
    public _shared: SharedService,
    private globalFilterService: GlobalFilterService,
  ) {
    this.menuItems = menu.getMenu();
    this.setAllowedMenus();
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event.url == '/app/finance' /* || event.url == '/app/finance-customer'  */ || event.url == '/app/process-payment/payment' || event.url == '/app/accounts-receivable/send-invoice' || event.url == '/app/trainings/schedule' || event.url.includes('/app/agreement') || event.url == '/app/help/trainings/schedule') {
        this.locationDisabled = true;
      } else {
        this.locationDisabled = false;
      }

      if (event.url == '/app/open-api/pay-over-time' || event.url == "/app/open-api/pre-approval-leads") { this.prevshowAlloption = this.showAlloption; this.showAlloption = false; } else {
        this.showAlloption = this.prevshowAlloption || true;
      }
      this.deleteLeadsStoredData(event.url)
    });

    if (this.userProfileData.role_id == 4) {
      this.financeData = JSON.parse(localStorage.getItem('getFinanceValues'));
      if (!this.financeData || this.financeData == undefined) {
        this.mainService.getFinanceValues(this.userProfileData.doctor_id);
      }
    } else if (this.userProfileData.role_id == 1) {
      let selectedProfile = this.globalFilterService.getFilterObj('location');

      if (selectedProfile && selectedProfile.name != 'All') {
        this.locationId = selectedProfile.id;
      }

      if (this.locationId) {
        this.locationData = this.locationId;
      } else {
        this.locationData = 'All'
      }

      this.globalSubscription = this.globalFilterService.getGlobalFilter().subscribe((data: any) => {
        if (data && data[0]) {
          if (data[0].id == -1 || !data[0].id) {
            this.locationData = 'All'
            this.locationId = '';
          } else {
            this.locationId = data[0].id;
            this.locationData = data[0].id;
          }
        }
      })
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (window.location.pathname == '/app/finance')
      this.collapseSideBar();
  }

  collapseSideBar() {
    let screenWidth = window.innerWidth;
    if (screenWidth <= 1580) {
      this.toggleExpand(false);
    } else {
      this.toggleExpand(true);
    }
  }

  toggleExpand(value): void {
    this.isExpanded = value;
    this.mainService.setExpandedState(this.isExpanded);
  }
  showSubscription = true;
  ngOnInit() {
    this.toggleExpand(true);
    this.mainService.sidebarToggleRequest$.subscribe((isExpanded) => {
      this.toggleExpand(isExpanded);
    });
    this.mainService.sidebarVisibilityRequest$.subscribe((isVisible) => {
      this.sidenavHidden = !isVisible;
    });
    this.path = window.location.pathname;
    this.getAllLocation();
    this.authService.doctorDefaultVales$.subscribe((data) => {
      this.doctorSettings = data;
      if (this.doctorSettings && this.doctorSettings.pp_subscription_settings) {
        const value = this.doctorSettings.pp_subscription_settings;
        this.doctorSettings.pp_subscription_settings = (typeof value === 'string') ? JSON.parse(value) : value;

        this.showSubscription = !!this.doctorSettings.pp_subscription_settings.show_pp_subscription;
      }
      this.setAllowedMenus();
    })
    this.mainService.getLocationFilter.subscribe((res: any) => {
      if (res) {
        this.locationData = res.id || res.doctor_id;
      }
    })

    // The subscription flow type is location-scoped and, for an agent, only
    // arrives with get_can_finance_status — which resolves after the location
    // switch that asked for it. Rebuild the menu when it lands, otherwise the
    // Subscription v2 entries stay filtered out on settings that are stale.
    this.mainService.financeData$.subscribe(() => {
      this.setAllowedMenus();
    });

    this.mainService.arProposals.subscribe((data: any) => {
      this.arProposalCount = data;
    });

    this.mainService.available_menu.subscribe(server_menu => {
      this.setAllowedMenus();
    });

    this.show_white_background = this.white_background_menus.includes(window.location.pathname);
    this.router.events.subscribe((): void => {
      this.show_white_background = this.white_background_menus.includes(window.location.pathname);
    });

    this.mainService.profileImage.subscribe((res: any) => {
      this.selectedProfileImage = res.doctor_image;
    })

    this.authService.userProfileData$.subscribe((res: any) => {
      if (res[0] && res[0].role_id !== 5) {
        this.doctorInfo = res[0];
        if (res[0].doctor_first_name) {
          this.firstName = res[0].doctor_first_name + ' ' + res[0].doctor_last_name;
        }
        if (res[0].enterprise_first_name) {
          this.firstName = res[0].enterprise_first_name + ' ' + res[0].enterprise_last_name;
        }

        if (res[0].practice_name) {
          this.practiceName = res[0].practice_name;
          if (this.practiceName && this.practiceName.length > 15) {
            this.practiceName = this.practiceName.slice(0, 15) + "…";
          }
        }
      }
    })

    this._socket.socket.on('new_notification', (data) => {
      this.mainService.unread_count = data.unread_count;
      if (data && data.data) {
        if (data && data.data.length > 10) {
          this.mainService.notification_list = data && data.data.slice(0, 10);
        } else {
          this.mainService.notification_list = data && data.data;
        }
      }
      this.mainService.notification_list && this.mainService.notification_list.forEach(element => {
        element.show_sent_at = this.mainService.covertDateTimesAgo(element.sent_at)
      });
    })

    this.authService.userProfileData$.subscribe(data => {
      if (data && data.length > 0) {
        this.userProfileData = data[0]
      }
      this.setAllowedMenus();
    })

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentPath = event.urlAfterRedirects;
        console.log('URL changed:', currentPath);

        if (currentPath == '/app/finance')
          this.collapseSideBar();
        else
          this.toggleExpand(true);
      });

    this.mainService.getAllLocations.subscribe((data) => {
      if (data) {
        this.getAllLocation();
      }
    })

    this.authService.userProfileData$.subscribe((data) => {
      if (data) {
        this.instant_payout_config = data[0].instant_payout_config;
        this.show_payout = (this.instant_payout_config && this.instant_payout_config.show_payout) ? this.instant_payout_config.show_payout : 0;
      }
    });
    document.body.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  isCurrentRoute(item: any) {
    let currentPath = window.location.pathname;
    if (currentPath.indexOf("/app/contract/details") !== -1) {
      currentPath = "/app/contract/list";
    }
    else if (currentPath.indexOf("/app/accounts-receivable/details") !== -1) {
      currentPath = "/app/accounts-receivable/list";
    }
    else if (currentPath.indexOf("/app/process-payment/details") !== -1) {
      currentPath = "/app/process-payment/list";
    }
    return currentPath.indexOf(item.path) !== -1;
  }

  goToDashboard() {
    this.router.navigate(['app/finance-customer']);
    // if (this.userProfileData.role_id == 5) {
    //   this.router.navigate(['/app/finance-customer']);
    // } else {
    //   this.router.navigate(['app', 'dashboard']);
    // }
  }

  public getAllLocation(value?: any) {

    const data: any = {
      access_token: localStorage.getItem('token'),
      limit: 100,
      case: 1,
      search_string: value ? value : '',
    };

    if (this.locationType) {
      data.location_type_id = this.locationType.location_type_id;
    }
    if (this.locations && this.locations.length == 0) {
      this.mainService.api(data, `get_all_locations`, false, 'object')
        .subscribe(response => {
          this.locations = [];
          if (response.is_error == 0) {
            this.locations = response.data;
            if (this.locations && this.locations.length > 0) {
              this.locations && this.locations.forEach(location => {
                if (!location.location_name && !location.practice_name) {
                  location.practice_name = location.doctor_first_name + ' ' + location.doctor_last_name;
                }
              });
              this._shared.locations = this.locations;
              if (this.locations && this.locations.length == 1) {
                this.showAlloption = false;
                this.locationData = this.locations[0].doctor_id;
                if (this.userProfileData.role_id !== 4) {
                  this.onSelectLocation(this.locations[0].doctor_id);
                }
              } else if (this.userProfileData.role_id !== 5) {
                this.showAlloption = true;
                this.autoSelectDefaultDoctor();
                // this.locationData = 'All';
                if (window.location.pathname == '/app/global-settings') {
                  this.showAlloption = false;
                }
              } else if (this.userProfileData.role_id == 5) {
                this.showAlloption = false;
                if (this.locations && this.locations[0]) {
                  this.locationData = this.locations[0].doctor_id;
                  this.onSelectLocation(this.locations[0].doctor_id);
                }
              }

              if (window.location.pathname == '/app/open-api/pay-over-time') {
                this.showAlloption = false;
              }

            }

            if (localStorage.getItem('currentLoc') && this.userProfileData.role_id !== 4) {
              let data = JSON.parse(localStorage.getItem('currentLoc'));
              let userloc = this.globalFilterService.getFilterObj('location');
              if (data.id == userloc.id) return;
              // this.locationData = userloc.id || ;
              this.onSelectLocation(this.locationData);
            }
            this.filteredOptions = of(this.locations);
            setStoredLocations(this.locations);
            this.applyFinanceThemeFromSelection(this.locationData);
            this.applySubscriptionVisibilityFromSelection(this.locationData);

          }
        });
    }
  }

  // Once per login, preselect the enterprise's default doctor (email_login profile[0].default_doctor_id).
  private autoSelectDefaultDoctor(): void {
    const defaultDoctorId = this.userProfileData?.default_doctor_id;
    if (this.userProfileData?.role_id != 1 || !defaultDoctorId || sessionStorage.getItem('defaultDoctorApplied')) {
      return;
    }
    sessionStorage.setItem('defaultDoctorApplied', '1');
    if (this.locations.some(item => item.doctor_id == defaultDoctorId)) {
      this.locationData = defaultDoctorId;
      this.onSelectLocation(defaultDoctorId);
    }
  }

  private applyFinanceThemeFromSelection(selection?: number | string): void {
    if (!this.locations?.length) {
      return;
    }

    const selected = selection === 'All' || !selection ? 'All' : selection;
    this.mainService.setFinanceThemeFromLocations(this.locations, selected);
  }

  private applySubscriptionVisibilityFromSelection(selection?: number | string): void {
    if (!this.locations?.length) {
      return;
    }

    this.showSubscription = this.mainService.getShowPpSubscriptionFromLocations(this.locations, selection);
    this.setAllowedMenus();
  }

  onSelectLocation(loc) {
    let entLocation = [];
    let val = loc;
    if (this.locations && this.locations.length > 0) {
      entLocation = this.locations.filter(item => item.doctor_id == val);
    }
    if (loc) {
      this.locationId = '';
      let filterObj: GlobalFilterObj = {
        type: 'location',
        name: val == 'All' ? 'All' : entLocation && entLocation[0] && entLocation[0].practice_name,
      }

      localStorage.removeItem('doctorSettings');

      if (val === 'All') {
        this.mainService.resetActiveFinanceDoctor();
      } else if (entLocation && entLocation[0]) {
        this.locationId = entLocation[0].doctor_id;
        filterObj.id = entLocation[0].doctor_id;
        filterObj.ind_id = entLocation[0].ind_id;
        filterObj.bsa_form_type = entLocation[0].bsa_form_type;
        filterObj.practice_name = entLocation && entLocation[0] && entLocation[0].practice_name;
        this.mainService.getFinanceValues(entLocation[0].doctor_id);
      } else {
        this.mainService.resetActiveFinanceDoctor();
      }

      const applyTheme = () => this.applyFinanceThemeFromSelection(val);
      const applySubscriptionVisibility = () => this.applySubscriptionVisibilityFromSelection(val);

      let data = {
        access_token: localStorage.getItem('token'),
        doctor_id: this.locationId,
      }
      if (this.locationId) {
        this.mainService.api(data, `switch_doctor`, false)
          .subscribe(response => {
            this.mainService.init()
            this.globalFilterService.setGlobalFilter(filterObj);
            applyTheme();
            applySubscriptionVisibility();
            this.filteredOptions = of(this.locations);
            this.valueChanged();
          })
      } else {
        this.mainService.init()
        this.globalFilterService.setGlobalFilter(filterObj);
        applyTheme();
        applySubscriptionVisibility();
        this.filteredOptions = of(this.locations);
        this.valueChanged();


      }
    }
  }

  public valueChanged() {
    this.getUserSelected.emit(true);
  }

  getShared() {
    if (this.locations && this.locations.length > 0) {
      if (this.userProfileData.role_id !== 4) {
        this._shared.getSelectedBusiness('/app/finance-customer', '', true);
      }
      else {
        this.router.navigate(['/app/finance-customer']);
      }
    }
    else {
      if (this.userProfileData.role_id == 1) {
        this.mainService.customPopups("Please enter business location to start finanacing.", 2);
      }
    }
  }

  setAllowedMenus() {
    this.menuItems = this.menu.getMenu();
    let userProfileData = getUserProfiles();
    let doctorSettings = getDoctorSettings();
    if ((userProfileData && userProfileData[0] && (userProfileData[0].role_id == 4))) {
      if (userProfileData[0].show_process_payment != 1 || userProfileData[0].business_verification_state != 'other_info_updated') {
        this.menuItems = this.menuItems.filter(menu => !menu.link.includes('/app/process-payment/list'));
      }
      if (userProfileData[0].show_ar != 1) {
        this.menuItems = this.menuItems.filter(menu => !menu.link.includes('/app/accounts-receivable'));
      }
      if (userProfileData[0].show_financial_settings != 1) {
        this.menuItems = this.menuItems.filter(menu => menu.link != '/app/global-settings');
        this.menuItems = this.menuItems.map(menu => {
          if (menu.submenu && menu.submenu.length > 0) {
            return {
              ...menu,
              submenu: menu.submenu.filter((sub: any) => sub.link != '/app/global-settings')
            };
          }
          return menu;
        });
      }
    }

    if ((userProfileData && userProfileData[0] && userProfileData[0].role_id == 5)) {
      if (userProfileData[0].show_process_payment != 1) {
        this.menuItems = this.menuItems.filter(menu => !menu.link.includes('/app/process-payment/list'));
      }
      if (userProfileData[0].show_ar != 1) {
        this.menuItems = this.menuItems.filter(menu => !menu.link.includes('/app/accounts-receivable'));
      }
      if (userProfileData[0].show_financial_settings != 1 && userProfileData[0].agent_id != 4230 && userProfileData[0].agent_id != 4234) {
        this.menuItems = this.menuItems.filter(menu => menu.link != '/app/global-settings');
        this.menuItems = this.menuItems.map(menu => {
          if (menu.submenu && menu.submenu.length > 0) {
            return {
              ...menu,
              submenu: menu.submenu.filter((sub: any) => sub.link != '/app/global-settings')
            };
          }
          return menu;
        });
      }

    }

    if (!this.showSubscription) {
      this.menuItems = this.menuItems.filter(menu => menu.link != '/app/process-payment/subscriptions-list');
    }

    if (!this.showSubscription || !this.mainService.isSubscriptionV2Flow(this.locationData)) {//for subscription v2
      this.menuItems = this.menuItems.filter(menu => !menu.link || !menu.link.includes('/app/subscriptions'));
      this.menuItems = this.menuItems.map(menu => {
        if (menu.submenu && menu.submenu.length > 0) {
          return {
            ...menu,
            submenu: menu.submenu.filter((sub: any) => !sub.link || !sub.link.includes('/app/subscriptions'))
          };
        }
        return menu;
      });
    }

    if (doctorSettings && doctorSettings?.show_transaction_report != 1) {
      this.menuItems = this.menuItems.map(menu => {
        if (menu.submenu && menu.submenu.length > 0) {
          return {
            ...menu,
            submenu: menu.submenu.filter((sub: any) => sub.link !== '/app/reports/view-transactions')
          };
        }
        return menu;
      });
    }

    this.redirectIfCurrentRouteNotAllowed();
  }

  redirectIfCurrentRouteNotAllowed() {
    const currentPath = this.router.url.split('?')[0];
    if (
      !currentPath ||
      !currentPath.startsWith('/app/') ||
      currentPath === '/app/finance-customer' ||
      currentPath.includes('/migrate') ||
      currentPath.includes('open-api')
    ) {
      return;
    }

    const mainMenu = this.mainService.routerAuth.main_menu;
    if (mainMenu && mainMenu.length && !this.mainService.routerAuth.searchPath(mainMenu, currentPath)) {
      this.router.navigate(['/app/finance-customer']);
      return;
    }

    if (!this.showSubscription && currentPath.includes('/app/process-payment/subscriptions')) {
      this.router.navigate(['/app/finance-customer']);
      return;
    }

    if ((!this.showSubscription || !this.mainService.isSubscriptionV2Flow(this.locationData)) && currentPath.includes('/app/subscriptions')) {
      this.router.navigate(['/app/finance-customer']);
    }
  }

  logout() {
    this.dialog.open(LogoutComponentDialog, {
      width: '420px',
      panelClass: 'simpleDialog'
    });
  }

  click_menu_tab() {
    setTimeout(() => {
      this.ppViewMode = localStorage.getItem('ppViewMode');
      localStorage.setItem('ppViewMode', this.ppViewMode)
    }, 0);
    if (localStorage.getItem('freeze_url')) {
      this.menu.freeze_panel_url.next(true);
    }
  }
  deleteLeadsStoredData(url) {
    if (url != '/app/finance') {
      this._shared.clearLeadsData()
    }
  }

  goToReferPage() {
    this.authService.accessTokenLogin();
    this.router.navigate(['/app/business-refer']);
  }

  ngOnDestroy() {
    this._socket.closeSocket();
    this.globalSubscription && this.globalSubscription.unsubscribe();
    this.mainService.notification_list = [];
    this.mainService.unread_count = 0;
    document.body.removeEventListener('click', this.handleOutsideClick.bind(this));
  }

  goToInstancePayComponent() {
    if (this.instant_payout_config.total_payout == 0 || this.instant_payout_config.daily_remaining_payouts == 0) {
      setTimeout(() => {
        const button = this.isExpanded ? document.getElementById('instantPayoutBtn') : document.getElementById('instantPayoutIcon');
        if (button) {
          const rect = button.getBoundingClientRect();
          this.tooltipTop = this.isExpanded ? `${rect.top - 15}px` : `${rect.top - 21}px`;
          this.tooltipLeft = this.isExpanded ? `${rect.left}px` : `${rect.left - 180}px`;
          this.showTooltip = true;
        }
        setTimeout(() => {
          this.showTooltip = false;
        }, 3000);
      }, 0);
    } else {
      setTimeout(() => {
        this.router.navigate(['/app/instant-payout']);
      }, 100)
    }


  }

  openInstanPayModal() {
    this.dialog.open(SimpleDialogComponent, {
      width: '502px',
      height: '516px',
      panelClass: 'simpleDialog',
      data: {
        type: 945,
      }
    });
  }
  handleOutsideClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      !target.closest('#instantPayoutBtn') &&
      !target.closest('#toolTip')
    ) {
      this.showTooltip = false;
    }
  }


  getLocationName(location: any) {
    return location.split('@')[0];
  }

}

